module.exports = __webpack_public_path__ + "static/media/fcs.716a8a9f.svg";